export const dummyUserParticipant =
  '--pending||example.participant@example.com';
export const dummyUserAdmin = '--pending||example.admin@example.com';
export const dummyUserCoach = '--pending||example.coach@example.com';

export function isDummyUser(userId: string) {
  return (
    userId === dummyUserParticipant ||
    userId === dummyUserAdmin ||
    userId === dummyUserCoach
  );
}
